import { formatNumber } from '@/utils/formatNumber'

export const formatDecimalInput = (rawValue, maxFractionDigits = 2) => {
	const value = String(rawValue)
	const raw = value
		.replace(/,/g, ".")
		.replace(/[^0-9.]/g, "")
		.replace(/^\.+/, "")

	const [intPart = "", ...rest] = raw.split(".")
	const fracPart = rest.join("").slice(0, maxFractionDigits)
	const hasDot = rest.length > 0 || raw.endsWith(".")

	const intSpaced = formatNumber(intPart)
	return hasDot ? `${intSpaced}.${fracPart}` : intSpaced
}